import type { IDictionariesMap } from '@sravni/types/lib/dictionaries';
import type { IVitrinaConfig } from '@sravni/vitrina/lib/types/config/IVitrinaConfig';

import type { FetchConfigParams } from '../store/reducers/productPopupInfo';

import { ProxyClient } from './client/ProxyClient';

export const getProductConfig = async (params: FetchConfigParams): Promise<IVitrinaConfig> => {
  const { data } = await ProxyClient.get<IVitrinaConfig>('/product-config', { params });

  return data;
};

export const getDictionaries = async (): Promise<IDictionariesMap> => {
  const { data } = await ProxyClient.get<IDictionariesMap>('/dictionaries');

  return data;
};
